import {
  EntryResultEnum,
  ProofSuggestedRulingEnum,
  ProofTypeEnum
} from '@snapptinc/fraud-platform';

export { EntryResultEnum as ProofResultEnum, ProofSuggestedRulingEnum, ProofTypeEnum };

export enum ProofResultEditedReasonEnum {
  NONE = 'NONE',
  TEXT_INSERTION = 'TEXT_INSERTION',
  FRAUDULENT_PDF_PRODUCER = 'FRAUDULENT_PDF_PRODUCER',
  FONT_FAIL = 'FONT_FAIL',
  CREATION_DATE = 'CREATION_DATE',
  VISUAL_EDIT = 'VISUAL_EDIT',
  EASY_PAYROLL = 'EASY_PAYROLL',
  X_REF = 'X_REF',
  TEMPLATE = 'TEMPLATE',
  THREATLISTED_DOCUMENT = 'THREATLISTED_DOCUMENT',
  THREATLISTED_COMPANY = 'THREATLISTED_COMPANY',
  THREATLISTED_VISUAL_FEATURE = 'THREATLISTED_VISUAL_FEATURE',
  LINEARIZATION = 'LINEARIZATION',
  ERROR_NOTIFICATION = 'ERROR_NOTIFICATION',
  WARNING_NOTIFICATION = 'WARNING_NOTIFICATION',
  XMP = 'XMP',
  BYTE_CODE = 'BYTE_CODE',
  OBJECT_NUMBERS = 'OBJECT_NUMBERS',
  OTHER = 'OTHER'
}

export enum ProofResultInsufficientReasonEnum {
  NONE = 'NONE',
  SCANNED_DOCUMENTS = 'SCANNED_DOCUMENTS',
  PRINT_TO_PDF = 'PRINT_TO_PDF',
  INVALID_DOCUMENT_TYPE = 'INVALID_DOCUMENT_TYPE',
  MERGED_DOCUMENT = 'MERGED_DOCUMENT',
  FOREIGN_ISSUED_DOCUMENT = 'FOREIGN_ISSUED_DOCUMENT',
  CROPPED_DOCUMENT = 'CROPPED_DOCUMENT',
  PENDING_EMPLOYER_VERIFICATION = 'PENDING_EMPLOYER_VERIFICATION',
  CUSTOM = 'CUSTOM',
  CANNOT_FIND_BUSINESS_CONTACT_INFO = 'CANNOT_FIND_BUSINESS_CONTACT_INFO',
  MISSING_SALARY_HOURLY_RATE = 'MISSING_SALARY_HOURLY_RATE',
  MISSING_START_DATE = 'MISSING_START_DATE',
  MISSING_TITLE = 'MISSING_TITLE',
  MISSING_EMPLOYEE_NAME = 'MISSING_EMPLOYEE_NAME',
  NAME_DOES_NOT_MATCH = 'NAME_DOES_NOT_MATCH',
  EDITED_DOCUMENT_IN_SUBMISSION = 'EDITED_DOCUMENT_IN_SUBMISSION',
  MISSING_COMPANY_NAME = 'MISSING_COMPANY_NAME',
  MISSING_LETTERHEAD = 'MISSING_LETTERHEAD',
  MISSING_WEBSITE = 'MISSING_WEBSITE',
  DATE_EXCEEDS_REASONABLE_WINDOW = 'DATE_EXCEEDS_REASONABLE_WINDOW',
  UNVERIFIED_INCOME = 'UNVERIFIED_INCOME',
  NO_RESPONSE_NO_INCOME = 'NO_RESPONSE_NO_INCOME',
  UNVERIFIED_OFFER_LETTER = 'UNVERIFIED_OFFER_LETTER'
}

export enum ProofResultPassFail {
  PENDING = 'Pending',
  CLEAN = 'Passed',
  EDITED = 'Failed',
  UNDETERMINED = 'Undetermined'
}
